import React, {FC, useContext, useEffect, useState} from 'react'
import {useTranslation} from "react-i18next";
import BlankPage from "Components/Layout/BlankPage";
import LoadingButton from "Components/Button/LoadingButton";
import {UserContext} from "Vendor/Context/UserContextProvider";
import {BannerContext} from "Vendor/Context/BannerContextProvider";
import User from "Entity/User";
import FormEmpty from "Vendor/Components/FormEmpty";
import Dropzone from "Components/Dropzone";

const MainPage: FC = () => {
    const { t } = useTranslation()
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [success, setSuccess] = useState<boolean>(false)
    const { currentUser, setCurrentUser } = useContext(UserContext);
    const { setBanner } = useContext(BannerContext);
    const [files, setFiles] = useState<string[]>([])

    useEffect(() => {
        if (currentUser?.currentOrganization?.logo) {
            setFiles([currentUser?.currentOrganization?.logo])
        } else {
            setFiles([])
        }
    }, [currentUser])

    const onSubmit = () => {
        setIsLoading(true)
    }
    const onResponse = () => {
        setIsLoading(false)
    }
    const onSuccess = (data: User) => {
        setSuccess(true)
        setBanner({type: 'success', i18nTitle: 'app.save', i18nMessage: 'app.data_saved_message'})
        setCurrentUser(data)
    }
    const onUploadSuccess = (data: User) => {
        setBanner({type: 'success', i18nTitle: 'app.save', i18nMessage: 'app.upload_success_message'})
        setCurrentUser(data)
    }
    const onError = () => {
        setSuccess(false)
    }

    if (!currentUser || !currentUser.currentOrganization) return <></>

    return (
        <BlankPage>
            <Dropzone
                uploadPath="/admin/edition/setting/upload-logo"
                deletePath="/admin/edition/setting/remove-logo"
                files={files}
                setFiles={setFiles}
                multiple={false}
                onSuccess={onUploadSuccess}
            />
            <FormEmpty
                path={'/admin/edition/setting'}
                formPath={!!currentUser?.currentOrganization?.id}
                children={<div className="row justify-content-end align-items-center">
                    <div className="col-auto">
                        <LoadingButton type="submit" isLoading={isLoading}>
                            {t( 'app.validate' )}
                        </LoadingButton>
                    </div>
                </div>}
                method={currentUser?.currentOrganization?.id ? 'PATCH' : 'POST'}
                onSuccess={onSuccess}
                onSubmit={onSubmit}
                onResponse={onResponse}
                onError={onError}
            />
        </BlankPage>
    )
}

export default MainPage
